export default function shouldShowDot (doc) {
  return !!(
    doc.latestUpdateTimestamp && (
      !doc.latestReadTimestamp ||
      doc.latestUpdateTimestamp > doc.latestReadTimestamp
    )
  )
}
